import './style.scss';
import ErrorLogo from '../../images/logos/logo-10.png';
import { Button } from '@mui/material';

const ErrorHeader = () => {
    return <div className='error-header'>
        <div>
            <a href="/">
                <img src={ErrorLogo} width={220} />
            </a>
        </div>
        {/* <div>
            <Button
                variant='outlined'
                sx={{
                    borderRadius: '20px'
                }}
                onClick={() => window.location.href = 'https://priva.uvdesk.com/en/'}
            >
                Contact Us
            </Button>
        </div> */}
    </div>;
};

export default ErrorHeader;